import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner1 from '../../assets/banner1.png'

import {
 Container,
 Title,
 Content,
 Table,
 FilterContainer,
 FilterContainerSelect
} from './styles'

export function TemNoParqueBanner() {
 const title = 'Tem no Parque'
 const subtitle = 'Alterar Banner'

 const fields = useMemo(
  () => [
   {
    id: 'Tem No Parque Banner',
    imagem: String,
    title: String,
    status: Number
   }
  ],
  []
 )

 const {
  bannersTemNoParque,
  setBannersTemNoParque,
  orderBy,
  setOrderBy,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(bannersTemNoParque.length / limit)

 const handleOrderChange = event => {
  setOrderBy(event.target.value)
 }

 const loadBannersTemNoParque = useCallback(async () => {
  try {
   const response = await api.get(`banners-temnoparque?order=${orderBy}`)

   setBannersTemNoParque(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar os banners')
  }
 }, [orderBy, setBannersTemNoParque])

 useEffect(() => {
  loadBannersTemNoParque()
 }, [loadBannersTemNoParque])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadBannersTemNoParque}
     fields={fields}
     name="banners-temnoparque"
     title="Banner"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadBannersTemNoParque}
     id={id}
     name="banners-temnoparque"
     title="Banner"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadBannersTemNoParque}
     id={id}
     name="banners-temnoparque"
     folder="bannersTemNoParque"
     title="Banner"
    />
   )}

   <Header title={title} subtitle={subtitle} />
   <Container>
    <FilterContainer>
     <Title>Gerenciador de banners</Title>
     <FilterContainerSelect
      name="filter"
      id="filter"
      onChange={handleOrderChange}
     >
      <option value="mais_recentes">Mais Recentes</option>
      <option value="mais_antigos">Mais Antigos</option>
      <option value="asc">Ordem alfabética (A a Z)</option>
      <option value="desc">Ordem alfabética reversa (Z a A)</option>
      <option value="update_desc">Atualizações mais recentes</option>
      <option value="update_asc">Atualizações mais antigas</option>
     </FilterContainerSelect>
    </FilterContainer>
    {bannersTemNoParque.length <= 0 ? (
     <>Nenhum banner cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <td>Exibição</td>
         <td>Imagem</td>
         <td>Título</td>
         <td>Status</td>
         <td colSpan="2"></td>
        </tr>
       </thead>
       <tbody>
        {bannersTemNoParque &&
         bannersTemNoParque.slice(offset, offset + limit).map(banner => (
          <tr key={banner.id}>
           <td>{banner.id}</td>
           <td>
            <div>
             {banner.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/bannersTemNoParque/${banner.file}`}
               alt={banner.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{banner.title}</td>
           <td>
            {banner.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações do banner</Title>
    <Content>
     <div>
      <img src={banner1} alt="Banner principal" />
      <h3>Banner Principal</h3>
      <p>Formato: 1920 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
